import React from 'react';
import Spacer from './spacer';
import {VerticalTimeline, VerticalTimelineElement} from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import './timelinecustom.css';

import {AiFillCode,AiFillBook,AiFillTool} from 'react-icons/ai';

import experience from './experience.json';

function getIcon(type){
    switch(type){
        case 'programming':
            return <AiFillCode/>
        case 'teaching':
            return <AiFillBook/>
        case 'engineering':
            return <AiFillTool/>
        default: return null;
    }
}
export default function Workexperience() {
    return (
        <div style={{textAlign:"justify"}}>
            <h3>Work Experience</h3>
            <Spacer size={10}/>
            <div>
                As an undergraduate student, I have taken up various internship and work opportunity over the course of my undergraduate studies. 
                The following is a brief summary of my work experience and internships.
            </div>
            <Spacer size={20}/>
            <div>
                <VerticalTimeline
                    className="custom-line"
                    layout="1-column-left"
                >   
                    {
                        experience.map((value,index)=>{
                            return <VerticalTimelineElement date={value.date}
                                    contentStyle={{ background: '#f5f5f5', color: 'gray' }}
                                    contentArrowStyle={{ borderRight: '7px solid  #f5f5f5' }}
                                    iconStyle={{ background: '#f5f5f5', color: 'gray' }}
                                    icon={getIcon(value.type)}
                                >
                                <h4 className="vertical-timeline-element-title">{value.position}</h4>
                                <h6 className="vertical-timeline-element-subtitle">{value.company}</h6>
                                <div>
                                    <ul>
                                        {
                                            value.description.map((desc,index)=>{
                                                return <li style={{fontSize:"12px"}}>
                                                    {desc}
                                                </li>
                                            })
                                        }
                                    </ul>
                                </div>
                            </VerticalTimelineElement>
                        })
                    }
                </VerticalTimeline>
            </div>
        </div>
    );
}